import { ReactElement, useContext, useEffect, useState } from 'react';
import { Box, Grid } from "@mui/material";
import { AlertSrv, FxButton, FxCheckbox, FxSelect, session, useNavigation } from "../../components/fx";
import _ from "lodash";
import { useParams } from "react-router-dom";
import { TokenContext } from '../../context-helpers/TokenContext';
import * as Apps from "../../config/apps.json";

const Dashboard = (props: any) => {
    const openApp = (app: any) => {
        window.open(app.url, "_blank");
    }

    return (
        <div className="container-fluid">
            <Box className="content-heading">
                <Box className="page-title">Dashboard</Box>
            </Box>
            <Box className="content-body">
                <Box>
                    {Apps.prod.map((app: any, appIdx: any) => (
                        <FxButton sx={{width: "150px", margin : "20px"}} variant='outlined' key={appIdx} label={app.name} onClick={() => openApp(app)} />
                    ))}
                </Box>
            </Box>
        </div>
    );
}

export default Dashboard;
